export default "__VITE_ASSET__CmidsvPj__"